import React, { Component } from "react";

import { CModal, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Newton from "../../tools/Newton";
import { log } from "../../utils/log";

class ModalTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // title: ""
    };
  }

  renderItem(tool) {
    switch (tool) {
      case 15:
        return (
          <Newton
            activity={this.props.activity}
            students={this.props.students}
          />
        );
      default:
        <></>;
    }
  }

  createLog() {
    let tool = "";
    switch (this.props.tool) {
      case 15:
        tool = "Newton";
        break;
      default:
        break;
    }

    log(
      "access",
      this.props.currentRoute,
      `Acessou a ferramenta ${tool}${
        this.props.activity
          ? ` dentro da atividade com id ${this.props.activity}`
          : ""
      }`,
      this.props.tool,
      this.props.user.token,
      this.props.activity || null,
      this.props.general.active_roles.school_id || null
    );
  }

  render() {
    if (this.props.hideModal) {
      return (
        <div className="w-100 h-100" style={{ overflowY: "auto" }}>
          {this.renderItem(this.props.tool)}
        </div>
      );
    }

    return (
      <CModal
        show={this.props.show}
        onOpened={() => this.createLog()}
        onClose={this.props.onClose}
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>{this.props.title}</CModalTitle>
        </CModalHeader>
        <div className="w-100 h-100" style={{ overflowY: "auto" }}>
          {this.props.show && <>{this.renderItem(this.props.tool)}</>}
        </div>
      </CModal>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalTools);
